export enum RadioVariant {
  PRIMARY = 'primary',
  SECONDARY = 'secondary',
  SUCCESS = 'success',
  ERROR = 'error',
  WARNING = 'warning',
  INFO = 'info',
}

export enum RadioSize {
  SMALL = 'small',
  MEDIUM = 'medium',
}

export enum RadioState {
  DEFAULT = 'default',
  CHECKED = 'checked',
  HOVER = 'hover',
  FOCUS = 'focus',
  DISABLED = 'disabled',
  CHECKED_DISABLED = 'checked-disabled',
}

export const RADIO_SIZES = {
  [RadioSize.SMALL]: 16,
  [RadioSize.MEDIUM]: 20,
} as const;

export const RADIO_COLORS = {
  [RadioVariant.PRIMARY]: 'primary',
  [RadioVariant.SECONDARY]: 'secondary',
  [RadioVariant.SUCCESS]: 'success',
  [RadioVariant.ERROR]: 'error',
  [RadioVariant.WARNING]: 'warning',
  [RadioVariant.INFO]: 'info',
} as const;

export type RadioVariantType = keyof typeof RadioVariant;
export type RadioSizeType = keyof typeof RadioSize;
export type RadioStateType = keyof typeof RadioState;
